<template>
  <el-container v-title data-title="月报表" style="min-height:98vh">
    <el-header style="text-align: right; font-size: 12px; height: 105px; background-image: linear-gradient(to right, white , green);">
      <Top/>
    </el-header>
    <el-container>
      <el-aside width="200px" style="background-color: rgb(238, 241, 246)">
        <Menu @GoTo='goto'></Menu>
      </el-aside>
      <el-main style="width: 1px">
        <el-header style="height: auto; padding: 0; background-color: #FFF">
          <el-container>
            <el-header height="20px" style="padding: 0; background-color: #FFF">
              <el-breadcrumb separator="/">
                <el-breadcrumb-item>食堂管理</el-breadcrumb-item>
                <el-breadcrumb-item>月报表</el-breadcrumb-item>
              </el-breadcrumb>
            </el-header>
            <el-main>
              <el-form :inline="true" :model="searchForm" class="demo-form-inline" >
                <el-form-item label="学校">
                  <el-select v-model="searchForm.schoolId" filterable>
                    <el-option v-for="(item, index) in schoolList" :key="index" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="月份">
                  <el-date-picker
                    v-model="month"
                    type="month"
                    placeholder="选择月"
                    value-format="yyyy-MM">
                  </el-date-picker>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" :loading="isSearching" @click="statsCanteenAccount">查询</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" :loading="isDownloading" @click="downloadStatsCanteenAccount">下载</el-button>
                </el-form-item>
              </el-form>
            </el-main>
          </el-container>
        </el-header>
        <template>
          <el-tabs v-model="activeTab" type="card">
            <el-tab-pane label="学校增值账户" name="tab1">
              <el-table v-loading="loading" :data="tableData1" border stripe>
                <el-table-column v-for="(title, index) in tableTitleList" :key="index" :prop="title" :label="title" :width="title == '账户' ? 105 : 64">
                  <template slot-scope="scope">
                    <el-button v-if="title != '账户' && title != '期初' && title != '期末' && title != '总进' && title != '总出'" type="text" @click="statsCanteenAccountDetail(scope.row.id, title, '1')">{{scope.row[title] / 100}}</el-button>
                    <span v-if="title == '账户'">{{scope.row[title]}}</span>
                    <span v-if="title == '期初' || title == '期末' || title == '总进' || title == '总出'">{{scope.row[title] != null ? scope.row[title] / 100 : '-'}}</span>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="学校回收账户" name="tab2">
              <el-table v-loading="loading" :data="tableData2" border stripe>
                <el-table-column v-for="(title, index) in tableTitleList" :key="index" :prop="title" :label="title" :width="title == '账户' ? 105 : 64">
                  <template slot-scope="scope">
                    <el-button v-if="title != '账户' && title != '期初' && title != '期末' && title != '总进' && title != '总出'" type="text" @click="statsCanteenAccountDetail(scope.row.id, title, '2')">{{scope.row[title] / 100}}</el-button>
                    <span v-if="title == '账户'">{{scope.row[title]}}</span>
                    <span v-if="title == '期初' || title == '期末' || title == '总进' || title == '总出'">{{scope.row[title] != null ? scope.row[title] / 100 : '-'}}</span>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="用户账户" name="tab3">
              <el-table v-loading="loading" :data="tableData3" border stripe>
                <el-table-column v-for="(title, index) in tableTitleList" :key="index" :prop="title" :label="title" :width="title == '账户' ? 105 : 64">
                  <template slot-scope="scope">
                    <el-button v-if="title != '账户' && title != '期初' && title != '期末' && title != '总进' && title != '总出'" type="text" @click="statsCanteenAccountDetail(scope.row.id, title, '2')">{{scope.row[title] / 100}}</el-button>
                    <span v-if="title == '账户'">{{scope.row[title]}}</span>
                    <span v-if="title == '期初' || title == '期末' || title == '总进' || title == '总出'">{{scope.row[title] != null ? scope.row[title] / 100 : '-'}}</span>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="用户账户汇总" name="tab4">
              <el-table v-loading="loading" :data="tableData4" border stripe>
                <el-table-column v-for="(title, index) in ['期初', '总进', '总出', '期末']" :key="index" :prop="title" :label="title" :width="105">
                  <template slot-scope="scope">
                    <span>{{scope.row[title] != null ? scope.row[title] / 100 : '-'}}</span>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="充值等明细" name="tab5">
              <el-table v-loading="loading" :data="tableData5" border stripe>
                <el-table-column v-for="(title, index) in ['时间', '类型', '姓名', '金额', '操作员']" :key="index" :prop="title" :label="title" :width="['时间', '类型'].indexOf(title) != -1 ? 170 : 75">
                  <template slot-scope="scope">
                    <span v-if="['时间', '类型', '姓名', '操作员'].indexOf(title) != -1">{{scope.row[title]}}</span>
                    <span v-if="['金额'].indexOf(title) != -1">{{scope.row[title] != null ? scope.row[title] / 100 : '-'}}</span>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="消费汇总" name="tab6">
              <el-table v-loading="loading" :data="tableData6" border stripe>
                <el-table-column v-for="(title, index) in ['日期', '金额']" :key="index" :prop="title" :label="title" :width="['日期', '金额'].indexOf(title) != -1 ? 110 : 75">
                  <template slot-scope="scope">
                    <span v-if="['日期'].indexOf(title) != -1">{{scope.row[title]}}</span>
                    <span v-if="['金额'].indexOf(title) != -1">{{scope.row[title] != null ? scope.row[title] / 100 : '-'}}</span>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="退款汇总" name="tab7">
                <el-table v-loading="loading" :data="tableData7" border stripe>
                  <el-table-column v-for="(title, index) in ['日期', '金额']" :key="index" :prop="title" :label="title" :width="['日期', '金额'].indexOf(title) != -1 ? 110 : 75">
                    <template slot-scope="scope">
                      <span v-if="['日期'].indexOf(title) != -1">{{ scope.row[title] }}</span>
                      <span v-if="['金额'].indexOf(title) != -1">{{ scope.row[title] != null ? scope.row[title] / 100 : '-' }}</span>
                    </template>
                  </el-table-column>
                </el-table>
              </el-tab-pane>
            <el-tab-pane label="用户账户分账汇总" name="tab8">
              <el-table v-loading="loading" :data="tableData8" border stripe>
                <el-table-column v-for="(title, index) in ['期初', '充值相关', '消费相关', '期末']" :key="index" :prop="title"  :label="title" :width="105">
                  <template slot-scope="scope">
                    <span>{{scope.row[title] != null ? scope.row[title] / 100 : '-'}}</span>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
          </el-tabs>
        </template>
      </el-main>
      <!-- 弹窗页（交易明细） -->
      <el-dialog
        title="交易明细"
        :visible.sync="detailListDialogVisible"
        width="571px"
        :before-close="handleClose">
        <el-table :data="detailListTableData" border stripe>
          <el-table-column prop="insertTime" label="交易时间" width="170"></el-table-column>
          <el-table-column prop="userRealName" label="用户姓名" width="100"></el-table-column>
          <el-table-column prop="typeName" label="类型" width="190"></el-table-column>
          <el-table-column prop="amount" :formatter="yuanFormatter" label="交易额" width="70">
            <template slot-scope="scope">
              {{scope.row.amount != null ? scope.row.amount / 100 : '-'}}
            </template>
          </el-table-column>
        </el-table>
      </el-dialog>
    </el-container>
  </el-container>
</template>

<script>
import Top from './Top.vue'
import Menu from './Menu.vue'
export default ({
  components: {
    Menu,
    Top
  },
  data () {
    return {
      userInfo: {},
      schoolList: [],
      month: '',
      tableData1: [],
      tableData2: [],
      tableData3: [],
      tableData4: [],
      tableData5: [],
      tableData6: [],
      tableData7: [],
      tableData8: [],
      tableTitleList: ['账户', '期初', '总进', '总出'],
      loading: false,
      searchForm: {
        schoolId: null
      },
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        }
      },
      detailListDialogVisible: false,
      detailListTableData: [],
      isSearching: false,
      isDownloading: false,
      activeTab: 'tab1'
    }
  },
  mounted () {
    if (this.Cookie.get('userInfo') !== undefined && this.Cookie.get('userInfo') !== '') {
      this.userInfo = JSON.parse(this.Cookie.get('userInfo'))
      this.getSchoolList()
    }
    let now = Math.round(new Date().getTime() / 1000)
    if (this.Cookie.get('offsetSecond') !== undefined || this.Cookie.get('offsetSecond') !== '') {
      now += parseInt(this.Cookie.get('offsetSecond'))
      this.month = new Date(now * 1000).toISOString().split('T')[0].substring(0, 7)
    }
  },
  methods: {
    goto (url) {
      if (url === this.$route.path) return
      this.$router.push(url)
    },
    handleClose (done) {
      done()
    },
    getSchoolList () {
      let _this = this
      this.$axios.post(this.GLOBAL.host + '/school/list',
        this.$qs.stringify({
          currentUserId: _this.userInfo.id,
          filterCanteen: '1'
        })
      ).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            _this.schoolList = res.data.data.list
            if (_this.schoolList.length > 0) {
              _this.searchForm.schoolId = _this.schoolList[0].id
              _this.statsCanteenAccount()
            }
          } else {
            this.$message.error(res.data.message)
          }
        }
      })
    },
    statsCanteenAccount () {
      if (this.month === '') return
      let _this = this
      _this.tableTitleList = ['账户', '期初', '总进', '总出']
      _this.tableData1 = []
      _this.tableData2 = []
      _this.tableData3 = []
      _this.tableData4 = []
      _this.tableData5 = []
      _this.tableData6 = []
      _this.tableData7 = []
      _this.tableData8 = []
      _this.loading = true
      _this.isSearching = true
      this.$axios.post(this.GLOBAL.host + '/canteenAccount/statsCanteenAccount',
        this.$qs.stringify({
          schoolId: _this.searchForm.schoolId,
          accountantMonth: _this.month
        })
      ).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            if (res.data.data != null) {
              if (res.data.data.result1[0] != null) {
                _this.tableTitleList = []
                Object.keys(res.data.data.result1[0]).forEach((key) => {
                  if (key !== 'id') {
                    _this.tableTitleList.push(key)
                  }
                })
              }
              _this.tableData1 = res.data.data.result1
              _this.tableData2 = res.data.data.result2
              _this.tableData3 = res.data.data.result3
              _this.tableData4 = res.data.data.result4
              _this.tableData5 = res.data.data.result5
              _this.tableData6 = res.data.data.result6
              _this.tableData7 = res.data.data.result7
              _this.tableData8 = res.data.data.result8
            }
          } else {
            this.$message.error(res.data.message)
          }
        }
        _this.loading = false
        _this.isSearching = false
      })
    },
    statsCanteenAccountDetail (accountId, column, type) {
      let _this = this
      this.$axios.post(this.GLOBAL.host + '/canteenAccount/statsCanteenAccountDetail',
        this.$qs.stringify({
          yearMonth: _this.month,
          type: type,
          accountId: accountId,
          column: column
        })
      ).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            _this.detailListDialogVisible = true
            _this.detailListTableData = res.data.data != null ? res.data.data : []
          } else {
            this.$message.error(res.data.message)
          }
        }
      })
    },
    yuanFormatter (row, column, value) {
      if (column.label != null && ['账户', '时间', '类型', '姓名', '金额', '操作员'].indexOf(column.label) !== -1 && value !== 0) {
        if (value === undefined) {
          return '-'
        } else {
          return Number((value / 100).toFixed(2))
        }
      } else {
        return value
      }
    },
    downloadStatsCanteenAccount () {
      if (this.month === '') return
      let _this = this
      _this.isDownloading = true
      this.$axios.post(this.GLOBAL.host + '/canteenAccount/downloadStatsCanteenAccount', this.$qs.stringify({
        schoolId: _this.searchForm.schoolId,
        accountantMonth: _this.month
      }), {
        responseType: 'blob'
      }).then(res => {
        if (res.data != null) {
          let errorMessage = ''
          let reader = new FileReader()
          reader.onload = function () {
            try {
              let response = JSON.parse(reader.result)
              if (response != null && response.message != null) {
                errorMessage = response.message
                console.log('errorMessage-111111')
                console.log('errorMessage: ' + errorMessage)
                _this.$message.error(errorMessage)
              }
            } catch (e) {
              let contentDisposition = res.headers['content-disposition']
              console.log(contentDisposition)
              let fileName = window.decodeURI(contentDisposition.substring(contentDisposition.indexOf('=') + 1))
              let blob = new Blob([res.data], {type: 'application/vnd.ms-excel'})
              let url = window.URL.createObjectURL(blob)
              const link = document.createElement('a')
              link.href = url
              link.download = fileName // 重命名文件
              link.click()
              URL.revokeObjectURL(url) // 释放内存
            }
          }
          reader.readAsText(res.data)
        }
        _this.isDownloading = false
      })
    }
  }
})
</script>
<style>
  .grid-content {
    min-height: 25px;
    line-height: 25px;
    padding: 2px;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/CanteenMonthReport.vue